import Card from "react-bootstrap/Card";
import { useNavigate } from "react-router";

function CardContainer({ width, height, icon, title, description, url }) {
  const navigate = useNavigate();

  return (
    <Card
      className="custom-card"
      style={{
        width: width,
        margin: "1rem",
        height: height,
        cursor: "pointer",
      }}
    >
      <Card.Body
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          {...(url && {
            onClick: () => {
              navigate(url);
            },
          })}
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "0.5rem",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <div> {icon}</div>
          <div style={{ textAlign: "left" }}>
            <h5>{title}</h5>
            <p>{description}</p>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default CardContainer;
